import { axiosInstance } from "../src/axios.js"
import { mountVueApp, logError, loadClientIcons } from '../src/vue_loader_helpers.js'
import { toastPlugin } from 'plugins/toast_plugin.js'
import { confirmPlugin } from 'plugins/confirm_plugin.js'
import { screenSizePlugin } from 'plugins/screen_size_plugin.js'
import { createPinia } from 'pinia'

import { router } from 'routers/client_platform.js'


const pinia = createPinia()
/* Depracation Warning - new features should use the client router BEn will have a breakdown if you add */
const CLIENT_COMPONENT_REGISTRY = {
  ClientBudgetsSpendVBudgetedChart: {
    componentName: 'ClientBudgetsSpendVBudgetedChart',
    path: 'components',
    targetId: 'spend-v-budgeted-chart-vue-app',
  },
  ClientPlatformApp: {
    componentName: 'ClientPlatformApp',
    path: 'views',
    targetId: 'client-platform-vue-app',
    plugins: [router, pinia, toastPlugin, screenSizePlugin, confirmPlugin],
  },
  UnwrappedPage: {
    componentName: 'UnwrappedPage',
    path: 'views',
    targetId: 'unwrapped-page-vue-app',
    plugins: [screenSizePlugin, toastPlugin],
  },
}

function bindInvisibleEventBridge() {
  const bridge = document.getElementById('invisible-event-bridge')

  if (bridge) {
    bridge.addEventListener('payloadRequest', function(e) {
      e.stopPropagation()
      axiosInstance({
        method: 'get',
        url: e.detail['path'],
        params: e.detail['params'],
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        },
      }).then(response => {
        eval(response.data)
      })
      .catch(error => {
        console.error(error)
      })
    })
  }
}

const withLogging = (fn) => (name) => {
  try {
    fn(name)
  } catch (err) {
    logError(err, name)
  }
}


const mountVueAppByName = withLogging((name) => {
  const config = CLIENT_COMPONENT_REGISTRY[name]

  if (!config) {
    throw new Error(`Component ${name} not found in CLIENT_COMPONENT_REGISTRY`)
  }

  const { componentName, path, targetId, plugins } = config

  const element = document.getElementById(targetId)
  if (!element) return

  mountVueApp({
    componentName,
    path,
    targetId,
    plugins,
  })
})

document.addEventListener("DOMContentLoaded", () => {
  bindInvisibleEventBridge()
  loadClientIcons()
  Object.keys(CLIENT_COMPONENT_REGISTRY).forEach((componentName) => {
    mountVueAppByName(componentName)
  })
})

const mountSupportPageComponent = () => {
  mountVueAppByName('ClientSupportPage')
}

const mountClientBudgetsSpendVBudgetedChart = () => {
  mountVueAppByName('ClientBudgetsSpendVBudgetedChart')
}

window.ClientBudgetsSpendVBudgetedChart = mountClientBudgetsSpendVBudgetedChart
window.mountVueAppByName = mountVueAppByName
window.mountSupportPageComponent = mountSupportPageComponent
